<template>
    <div>
        <b-alert v-if="message.status == 'Error'" show variant="danger">
            <h4 class="alert-heading"> {{$t('general.error')}} </h4>
            <p> {{errMsg}} </p>
            <hr>
            <p class="mb-0"> {{message.message}} </p>
        </b-alert>
        <form ref="form">
            <b-form-group>
                <b-row>
                    <b-col sm="4"> <label for="accountNo"> Name </label> </b-col>
                    <b-col sm="8"> <b-form-input id="name" v-model="name" placeholder="Name" /></b-col>
                </b-row>
            </b-form-group>
        </form>
    </div>
</template>

<script>
    import i18n from '@/plugins/i18n';
    export default {
        name: "Subscriptions",
        data: function () {
            return {
                name: this.data ? this.data.name : "",
                errMsg: "",
            }
        },
        props:{
            data: Object,
            save: Boolean,
            saveState: Function,
            modalName: String,
            modalEvent: Function,
        },
        computed:{
            message(){
                return this.$store.getters.getStatus
            },
        },
        watch:{
            data: function (val){
                this.name = val ? val.name : ""
            },
            save: async function(data){
                if(data){
                    let val = {
                        name: this.name,
                        id: this.data ? this.data.id : 0
                    }
                    switch(this.modalName){
                        case "add":
                            await this.$store.dispatch('addSubscription', val)
                            break;
                        case "edit":
                            await this.$store.dispatch('editSubscription', val)
                            break; 
                         case "delete":
                            await this.$store.dispatch('deleteSubscription', val)
                            break; 
                    }
                    if(this.$store.getters.getStatus.status == "Success"){
                        await this.$store.dispatch('subscription_list')
                        this.name = ""
                    }else{
                        this.errMsg = i18n.t('defination.subscriptions.addErrMsg')
                    }
                   
                }
                this.saveState(false)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/Subscriptions.vue